export default __webpack_public_path__ + "static/media/spring.b5902ef5.png";